import router from "@/router";
import { Task } from "@/types";

export function getTaskOfferReference(task: Task): string | undefined {
  const vars = task.variables as Record<string, unknown> | undefined;
  if (!vars) {
    return undefined;
  }
  const offerReference = vars.offerReference as { value?: string } | string | undefined;
  if (offerReference && typeof offerReference === "object" && offerReference.value) {
    return offerReference.value;
  }
  if (typeof offerReference === "string" && offerReference.length > 0) {
    return offerReference;
  }
  return undefined;
}

export function navigateToTaskDetail(task: Task) {
  const offerRef = getTaskOfferReference(task);
  return router.push({
    name: "TaskDetail",
    params: { taskId: task.taskId },
    query: offerRef ? { offerRef } : {},
  });
}
